<template>
  <span
    style="
      border-width: 1px;
      z-index: 1;
      border-style: solid;
      border-radius: 5px;
      margin-left: 4px;
      margin-right: 4px;
      padding-bottom: 2px;
    "
    :style="isDarkMode ? 'border-color: rgb(98,98,98)' : 'border-color: rgb(198,198,198)'"
  />
</template>
<script lang="ts">
import { ConfigModule } from "@/store/modules/config";
import { Component, Vue } from "vue-property-decorator";

@Component({
  components: {}
})
export default class TemplateEditorActionDivider extends Vue {
  get isDarkMode() {
    return ConfigModule.darkMode;
  }
}
</script>
